import React from 'react';

const BasicButton = ({ buttonTxt, buttonType, buttonSize = 'md', onClick, disabled }) => {
  return (
    <button
      type={'button'}
      disabled={disabled}
      className={`button-default basic-button ${buttonType} ${buttonSize}`}
      onClick={onClick}
    >
      {buttonTxt}
    </button>
  );
};

export default BasicButton;
